// External links on this site come from places we don't control: automation
// proposals built from scraped pages and LLM output (issue #404), user-submitted
// glossary sources, admin-entered resources. React warns about javascript: hrefs
// in development but renders them in production, so every dynamic URL that
// reaches an href or window.open goes through here first. Only absolute http(s)
// URLs pass; anything else -- javascript:, data:, vbscript:, relative paths,
// unparseable strings -- yields null and the caller renders plain text instead.
const SAFE_PROTOCOLS = new Set(['http:', 'https:'])

export const safeHref = (url) => {
    if (typeof url !== 'string') return null
    const trimmed = url.trim()
    if (!trimmed) return null
    let parsed
    try {
        parsed = new URL(trimmed)   // no base: relative URLs throw -> rejected
    } catch {
        return null
    }
    // The WHATWG parser strips leading C0 controls/whitespace and embedded
    // tab/newline before reading the scheme, exactly as the browser does for an
    // href, so '\u0001javascript:' and 'java\tscript:' are judged by the scheme
    // the browser would actually use.
    return SAFE_PROTOCOLS.has(parsed.protocol) ? trimmed : null
}

// window.open counterpart for the card/list/modal "View" buttons.
export const openExternal = (url) => {
    const href = safeHref(url)
    if (href) window.open(href, '_blank', 'noopener,noreferrer')
}
